var _excluded = ["as", "align", "children", "display", "direction", "justify", "sx"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import MuiBox from '@material-ui/core/Box';
var Box = forwardRef(function (_ref, ref) {
  var as = _ref.as,
    align = _ref.align,
    children = _ref.children,
    display = _ref.display,
    direction = _ref.direction,
    justify = _ref.justify,
    sx = _ref.sx,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  var flexProps = {};
  if (display === 'flex' || display === 'inline-flex') {
    flexProps = {
      flexDirection: direction,
      alignItems: align,
      justifyContent: justify
    };
  }
  return /*#__PURE__*/React.createElement(MuiBox, _extends({
    component: as,
    ref: ref,
    sx: _extends({
      display: display
    }, flexProps, sx)
  }, rest), children);
});
Box.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The component used for the root node.
   */
  as: PropTypes.oneOf(['aside', 'div', 'footer', 'header', 'main', 'nav', 'section', 'span']),
  /**
   * Defines css `align-items` property
   */
  align: PropTypes.oneOf(['flex-start', 'center', 'flex-end', 'stretch']),
  /**
   * Box render function or node.
   */
  children: PropTypes.node.isRequired,
  /**
   * Defines css `display` property
   */
  display: PropTypes.oneOf(['block', 'flex', 'inline-block', 'inline-flex']),
  /**
   * Defines css `display` property
   */
  direction: PropTypes.oneOf(['row', 'row-reverse', 'column', 'column-reverse']),
  /**
   * Defines css `justify-content` property
   */
  justify: PropTypes.oneOf(['flex-start', 'center', 'flex-end', 'space-around', 'space-between', 'space-evenly']),
  /**
   * Accepts all system properties, as well as any valid CSS properties.
   * @see: https://next.material-ui.com/system/properties/
   */
  sx: PropTypes.object
} : {};
Box.defaultProps = {
  as: 'div',
  align: 'flex-start',
  display: 'block',
  direction: 'row',
  justify: 'flex-start',
  sx: {}
};
export default Box;